import { FC } from 'react';
import { Box, Typography, Button } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import emptyImg from '../../assets/empty-list-img.svg';

type IEmptyListMessage = {
	message: string;
	buttonLabel: string;
	onClick: () => void;
};

const EmptyListMessage: FC<IEmptyListMessage> = ({ message, buttonLabel, onClick }) => {
	return (
		<Box className="flex flex-col items-center justify-center rounded-lg bg-background-paper px-0 py-14">
			<Box className="w-80">
				<img src={emptyImg} alt="empty list img" className="h-60" />
				<Box className="mx-4 flex flex-col text-center">
					<Typography className="mb-6 mt-8 text-2xl font-medium text-text-primary">{message}</Typography>
					<Button onClick={onClick} className="w-full" size="large" endIcon={<KeyboardArrowLeftIcon />}>
						{buttonLabel}
					</Button>
				</Box>
			</Box>
		</Box>
	);
};

export default EmptyListMessage;
